import React, { useCallback } from "react";
import { useHistory } from "react-router-dom";
import PropTypes from "prop-types";
import { Button, Icon } from "rbx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useApolloClient } from "react-apollo";
import moment from "moment";
import { OrdersTable } from "../../../../components/Orders";
import { ROUTE_VERIFIED_COLUMNS } from "../columns";
import { downloadCSV } from "../../../../utils";
import { ALL_ORDERS_VIEW_BY_PAGE_QUERY } from "../../../../graphql/Orders/Orders.graphql";
// import { ALL_ORDERS_VIEW_BY_PAGE_QUERY } from "../../../DispatchProcessing/Orders/OrdersPage";
import { useSystemCodes } from "../../../../utils/hooks";
import Loading from "../../../../components/Loading";

const Cancelled = ({ date }) => {
  const SystemCodes = useSystemCodes({
    Category: "Order",
    CodeName: "OrderStatus",
    CodeId: "CAN"
  });
  const history = useHistory();
  const client = useApolloClient();

  const handleExport = useCallback(() => {
    downloadCSV(
      client,
      {
        query: ALL_ORDERS_VIEW_BY_PAGE_QUERY,
        where: {
          RequestedDeliveryDate_lt: date,
          StatusRecIdRef: SystemCodes?.data[0]?.RecId
        }
      },
      "VW_OrdersByPage",
      ROUTE_VERIFIED_COLUMNS
    );
  }, [SystemCodes, client, date]);

  if (!SystemCodes || !SystemCodes.data || SystemCodes?.loading) {
    return <Loading />;
  }

  return (
    <React.Fragment>
      <div className="page-head">
        <div className="page-head-start">Cancelled</div>
        <div className="page-head-end">
          <Button color="primary" onClick={handleExport}>
            <Icon>
              <FontAwesomeIcon icon="file-export" />
            </Icon>
            <span>Export</span>
          </Button>
        </div>
      </div>
      <OrdersTable
        columns={ROUTE_VERIFIED_COLUMNS}
        initialSortBy={[
          {
            id: "ScheduledDeliveryDate",
            desc: false
          },
          { id: "OrderNumber", desc: false }
        ]}
        where={{
          ScheduledDeliveryDate_lt: moment(date)
            .endOf("day")
            .toDate(),
          StatusRecIdRef: SystemCodes?.data[0]?.RecId
        }}
        onCellClick={cell => {
          if (cell.column.id !== "selection") {
            history.push(`/dispatch/orders/${cell.row.original.RecId}/BOL-ELD`);
          }
        }}
      />
    </React.Fragment>
  );
};
Cancelled.propTypes = {
  date: PropTypes.string
};
export default Cancelled;
